import { createComponent } from '@carvana/merch-components';
import EVPlugIcon from '~/icons/EVPlugIcon';
import flattenWhiteSpace from '~/utilities/flattenWhiteSpace';

export const Container = createComponent('div', {
  className: flattenWhiteSpace(`
    bg-white
    border
    border-[#e2e8f0]
    h-fit
    mb-16
    overflow-hidden
    relative
    rounded-xl
    w-full
    m:h-[160px]
    m:mb-32
  `)
});

export const BackgroundImg = createComponent('img', {
  className: 'absolute right-0 top-[-250px] m:top-[-200px]'
});

export const MainContent = createComponent('div', {
  className: 'flex flex-col h-full relative w-full m:flex-row'
});

export const GreenCirlce = createComponent('section', {
  className: flattenWhiteSpace(`
    bg-[#a9e34b]
    flex
    h-[107px]
    items-center
    justify-center
    ml-[-40px]
    mt-[-38px]
    relative
    rounded-full
    shrink-0
    w-[107px]
    m:h-[224px]
    m:ml-[-73px]
    m:mt-[-31px]
    m:w-[224px]
  `)
});

export const PlugIcon = createComponent(EVPlugIcon, {
  className:
    'absolute bottom-20 h-[40px] right-20 w-[40px] m:bottom-[60px] m:h-[unset] m:right-32 m:w-[unset]'
});

export const TextSection = createComponent('section', {
  className: flattenWhiteSpace(`
    flex
    flex-1
    flex-col
    gap-8
    h-full
    justify-start
    p-16
    m:justify-center
    m:min-w-[222px]
    m:ml-36
    m:p-0
  `)
});

export const LargeText = createComponent('span', {
  className:
    'font-semibold leading-[28px] text-[28px] text-blue-6 m:leading-[40px] m:text-[40px]'
});
